export const project = {
  add: { label: "Add project" },
  additionalCosts: {
    add: "Add additional costs",
    addNewCost: "Add a new cost",
    type: "Cost type",
    details: "Details of additional costs",
    description: "Description",
    precision: "Precision",
    source: "Source",
    estimatedCost: "Amount",
    cumulatedAdditionalCosts: "Cumulated additional costs",
  },
  batchEdit: {
    confirmation:
      "{{ count }} projects will be updated with the batch edit. Check the options below.",
    properties: {
      label: "Properties to update",
      errors: {
        empty: "Please select properties to update.",
      },
    },
    userPlural: {
      label: "Users",
    },
  },
  create: { label: "Create Project" },
  delete: {
    label: "Delete Project",
  },
  associate: {
    confirmation: {
      associatedIntervention:
        "Intervention `{{intervention}}` is currently part of the `{{project}}` project",
      more: "+ {{count}} interventions already linked to other projects",
      title:
        "Do you really want to move interventions to project `{{project}}`",
    },
    success: {
      title: "Association made successfully!",
      description: "One intervention was associated",
      description_other: "{{count}} interventions were associated",
    },
    button: "Associate",
  },
  form: {
    associateWith: "Associate this project with",
    description: {
      label: "Description",
    },
    edit: {
      label: "Edit project",
    },
    dueDate: {
      label: "Due Date",
    },
    informations: "Project information",
    name: { label: "Name" },
    location: {
      label: "Location",
    },
    progress: {
      label: "Progress",
    },
    reference: {
      label: "Reference",
    },
    startDate: {
      label: "Start Date",
    },
    status: {
      label: "Status",
    },
    revisedInterventionsCost: {
      label: "Revised interventions cost",
    },
    documents: {
      label: "Attached files",
    },
    users: {
      label: "Users",
    },
  },
  list: {
    total: "Total",
    summaryTotalCost: "Total cost",
    interventionsTotalCost: "Interventions total cost",
  },
  statistics: {
    costPerState: {
      title: "Total cost per state",
    },
    countPerState: {
      title: "Projects count per state",
    },
    costPerYear: {
      title: "Increased cost of projects per year",
    },
  },
  costsCard: {
    title: "Totals",
    interventionsCost: "Interventions cost",
    revisedInterventionsCost: "Revised interventions cost",
    additionalCosts: "Additional costs",
    othersAdditionalCosts: "Other additional costs",
    addAdditionalCosts: "Add additional costs",
    editAdditionalCosts: "Edit additional costs",
    totalCost: "Total cost",
  },
};
